export const msalConfig = {
    auth: {
        clientId: "cda8b4f5-580e-41fa-9a16-f05b27592053",
        authority: "https://login.microsoftonline.com/da618d4c-c868-4013-bb1d-373038d375d1",
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    }
};
export const loginRequest = {
    scopes: ["api://cda8b4f5-580e-41fa-9a16-f05b27592053/access_as_user"]
};